export const StorageKeys = {
  securityTokens: 'auth_token',
  userType: 'user_type',
};
